export class LoginResponseModel {
  code!: string;
}
